import { useEffect, useState } from "react";
import Button from "../../components/button/Button";
import { UserPointAdjustmentModal } from "./UserPointAdjustmentModal";
import { PointHistoryExportModal } from "../pointHistory/PointHistoryExportModal";
import { UserPointHistorySearch } from "./UserPointHistorySearch";
import TableList, { GridCol, GridRow } from "../../components/table/TableList";
import { useParams } from "react-router-dom";
import { Spiner } from "../../components/spinner/Spiner";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { 
  PointHistoryData, 
  PointCategory, 
  PointType, 
  PointAdjustHistory, 
  newPointAdjustHistory,
  AdjustUsers,
  PtAwardedSettings,
} from "../../model/PointData";
import pointDataQuery from "../../firestore/PointData.query";
import { auth } from "../../firebase";
import { convertDateTimeToString } from "../../utility/ConvertUtily";
import { useNavigate } from "react-router-dom";
import { RegistConfirmationModal } from "../../components/modal/RegistConfirmationModal";
import userQuery from "../../firestore/User.query";
import { convertDateToString } from "../../utility/ConvertUtily";
import { UserData } from "../../model/Users";
import { SetStateAction } from "react";
import { Progress } from "../../components/progress/Progress";
import { Company } from "../../model/Companies";
import companiesQuery from "../../firestore/Companies.query";
import { checkOption } from "../../controller/OptionController";

export type UserPointHistoryListProps = {
  setSubmitFlg:  (value: SetStateAction<boolean>) => void;
  submitFlg: boolean;
  company: Company | undefined;
}

export const UserPointHistoryList = ({
  setSubmitFlg,
  submitFlg,
  company,
}: UserPointHistoryListProps) => {

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;
  // 利用者番号
  const { userId } = useParams<{ userId: string }>();
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [pointAdjustmentIsOpen, setPointAdjustmentIsOpen] = useState(false);
  const [selectNumber, setSelectNumber] = useState(50);
  const [isLoad, setIsLoad] = useState(true);
  const [loadProgress, setLoadProgress] = useState<number>(-1);
  const [userPointHistoryList, setUserPointHistoryList] = useState<PointHistoryData[]>([]);
  const [searchUserPointHistoryList, setSearchUserPointHistoryList] = useState<PointHistoryData[]>([]);
  const [searchUserPointHistoryFlg, setSearchUserPointHistoryFlg] = useState(false);
  const [ptNameList, setPtNameList] = useState<any[]>([]);
  const [pointCategoryList, setPointCategoryList] = useState<PointCategory[]>([]);
  const [pointTypeList, setPointTypeList] = useState<PointType[]>([]);
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [formData, setFormData] = useState<PointAdjustHistory>(newPointAdjustHistory);
  const [user, setUser] = useState<UserData>();
  const [modalMsg, setModalMsg] = useState<any>();
  const [firstPageFlg, setFirstPageFlg] = useState(false);
  const [ptAwardedSettingsList, setPtAwardedSettingsList] = useState<PtAwardedSettings[]>([]);

  useEffect(() => {
    const f = async () => {
      try {
        if(userId != undefined){
          //ポイント履歴の一覧を取得
          const userPointHistoryList = await pointDataQuery.getUserPointHistoryList(currentUser?.tenantId!, userId) as PointHistoryData[];
          setUserPointHistoryList(userPointHistoryList);
          //ポイント名取得
          const ptNameListAll = userPointHistoryList.map((pointHistory)=>pointHistory.ptName);
          const ptNameList = Array.from(new Set(ptNameListAll));
          setPtNameList(ptNameList)
          // ポイントカテゴリを取得
          const ptCategoryList = await pointDataQuery.getPointCategoryList();
          setPointCategoryList(ptCategoryList);
          // ポイントタイプを取得
          const ptTypeList = await pointDataQuery.getPointTypeList();
          setPointTypeList(ptTypeList);
          const user = await userQuery.getUser(currentUser?.tenantId!, userId) as UserData;
          setUser(user);
          // ptAwardedSettings取得
          const ptAwardedSettingsList = await pointDataQuery.getPtAwardedSettings(currentUser?.tenantId!);
          setPtAwardedSettingsList(ptAwardedSettingsList);
        }
      } catch (error) {
        console.error(error);
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
      setIsLoad(false);
      setFirstPageFlg(true)
    };
    f();
  }, [submitFlg, selectNumber]);

  // ポイント調整モーダルの開閉トリガー
  const AdjustmentToggle = () => {
    setPointAdjustmentIsOpen(!pointAdjustmentIsOpen);
  };

  // 履歴出力モーダルの開閉トリガー
  const PointHistoryExportToggle = () => {
    setIsOpen(!isOpen);
  };

  const selectNumberList =
    [
      { id: 50, name: "50" },
      { id: 100, name: "100" },
      { id: 200, name: "200" },
    ];

  const columns: GridCol[] = [
    {
      field: "ptCategory",
      headerName: "カテゴリ",
      style: "w-3/15",
      sort: false
    },
    {
      field: "ptType",
      headerName: "タイプ",
      style: "w-3/15",
      sort: false
    },
    {
      field: "name",
      headerName: "ポイント名",
      style: "w-3/15",
      sort: false
    },
    {
      field: "expirationDate",
      headerName: "有効期限",
      style: "w-2/15",
      sort: false
    },
    {
      field: "occurrenceDate",
      headerName: "ポイント発生日",
      style: "w-2/15",
      sort: false
    },
    {
      field: "tranType",
      headerName: "取引種別",
      style: "w-1/15",
      sort: false
    },
    {
      field: "grantPoints",
      headerName: "ポイント数",
      style: "w-1/15",
      sort: false
    },
    {
      field: "info",
      headerName: "",
      style: "",
      sort: false
    },
  ];

  const rowList: GridRow[] = (searchUserPointHistoryFlg? searchUserPointHistoryList : userPointHistoryList).map<GridRow>((item) => {
    const expirationDate = item.expirationDate as any;
    const occurrenceDate = item.occurrenceDate as any;
    return {
      rowData: {
        tranType: item.tranType,
        ptCategory: item.ptCategoryName,
        ptType: item.ptTypeName,
        name: item.ptName,
        expirationDate: expirationDate ? convertDateToString(new Date(expirationDate)) : "" ,
        occurrenceDate: occurrenceDate ? convertDateTimeToString(new Date(occurrenceDate)) : "",
        grantPoints: (<div className={"text-right 2xl:mr-2"}>{item.grantPoints}</div>),
        info: (<Button className={"sm:px-4 whitespace-nowrap"}  onClick={() => navigation(`${item.displayUserId}/${item.id}/info`)} >詳細</Button>),
        occurrenceDateTime: occurrenceDate,
        createDateTime: item.createAt
      },
      style: 'sm:whitespace-normal'
    };
  }); 

  // ポイント調整モーダル開閉
  const toggleConfirm = () => {
    setIsOpenConfirm(!isOpenConfirm);
  };

  // ポイント調整登録確認画面
  const onClickConfirm = async (data: any) => {
    try{
      setModalMsg(undefined);
      // 調整ポイント数を数字に変換して登録
      data.grantPoints = Number(data.grantPoints);
      setFormData(data);
      // 付与ポイントがマイナスの場合
      let warningMsg;
      if(data.grantPoints < 0 &&  userId && user){
        let heldPoints = 0;
        if(user.possessedPointMap){
          // 現在の保有ポイント数
          const keys = Object.keys(user.possessedPointMap);
          if(keys && keys.length > 0){
            for(let i = 0; i < keys.length; i++){
              const key = Number(keys[i]);
              if(Number(data.ptCategoryId) === key){
                heldPoints = user.possessedPointMap[key].point ?? 0;
              };
            };
          };
        };
        if(heldPoints + data.grantPoints <= 0){
          warningMsg = (
            <>{ConstMessage.REGIST_MODAL_TEXT}<br/>
              <div className={'text-red-500 mt-2'}>
                <span>{ConstMessage.WARN_MINUS_POINT}</span><br/>
                <span>保有ポイント数：{heldPoints}</span>
              </div>
            </>);
          setModalMsg(warningMsg);
        }else{
          setModalMsg(ConstMessage.REGIST_MODAL_TEXT);
        }
      }else{
        setModalMsg(ConstMessage.REGIST_MODAL_TEXT);
      }
      toggleConfirm();
    }catch(err){
      console.error(err);
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_UNEXPECTED, "danger")));
    }; 
  };

  // ポイント調整登録処理
  const onClickSubmit = async () => {
    try{
      if(userId && user){
        const ptCategoryId = Number(formData.ptCategoryId);
        const ptCategoryName = pointCategoryList?.filter((data) => data.categoryId === Number(formData.ptCategoryId))[0].categoryName ?? "";;
        const ptTypeName = pointTypeList?.filter((data) => data.typeId === formData.ptTypeId)[0].typeName ?? "";
        const occurrenceDate = new Date(formData.occurrenceDate);
        let occurrenceDateResult = new Date(occurrenceDate.getFullYear(), occurrenceDate.getMonth(), occurrenceDate.getDate());
        // 利用者の所属グループを取得
        const userGroups = (await userQuery.getGroups(userId)).filter(
          (group) => group.userId === userId && group.id !== "all" && group.id !== company!.displayId
        );
        // 団体グループ取得
        const groupList = (await companiesQuery.getGroups(currentUser?.tenantId!)).filter((group) => group.deleteFlg === false);
        const groupNameArr = [];
        for(let i = 0; i < userGroups.length; i++){
          const companyGroup = groupList.filter((companyGroup) => companyGroup.id === userGroups[i].id)[0];
          if(companyGroup){
            groupNameArr.push(companyGroup.name);
          }
        }
        const userData = await userQuery.getUser(currentUser?.tenantId!, userId) as UserData;
        
        // ポイント履歴の登録データ
        const pointHistory: PointHistoryData = {
          id: "",
          tenantId: currentUser?.tenantId!,
          userId: userId,
          displayUserId: userData.displayId ?? "",
          userName: userData.lastName ?? "",
          tranType: "調整",
          ptCategoryId: ptCategoryId,
          ptCategoryName: ptCategoryName,
          ptTypeId: formData.ptTypeId,
          ptTypeName: ptTypeName,
          ptName: formData.ptName,
          grantPoints: formData.grantPoints ?? 0,
          isBonus: false,
          occurrenceDate: occurrenceDateResult,
          grantFlg: false,
          note: formData.note,
          createAt: new Date(),
          updateAt: new Date(),
          expirationFlg: false,
        };
        // ポイント調整履歴・調整履歴対象者の登録データ
        const adjustUsersMap = [];
        const adjustUser: AdjustUsers = {
          id: "",
          tenantId: currentUser?.tenantId!,
          pointAdjustHistoryId: "",
          userId: userId,
          displayUserId: userData.displayId ?? "",
          userName: userData.lastName ?? "",
          executionResult: true,
        };
        if(groupNameArr.length > 0){
          adjustUser.groupNameArr = groupNameArr;
        }
  
        const pointAdjustData: PointAdjustHistory = {
          id: "",
          tenantId: currentUser?.tenantId!,
          ptCategoryId: ptCategoryId,
          ptCategoryName: ptCategoryName,
          ptTypeId: formData.ptTypeId,
          ptTypeName: ptTypeName,
          ptName: formData.ptName,
          grantPoints: formData.grantPoints,
          occurrenceDate: occurrenceDateResult,
          note: formData.note,
          createUser: currentUser?.displayName ?? "",
          createAt: new Date(),
          updateAt: new Date(),
        };
  
        // 即時付与の場合
        if(convertDateToString(occurrenceDateResult) === convertDateToString(new Date())){
          let heldPoints = 0;
          let possessedPoint = 0;
          if(userData){
            if(userData.possessedPointMap){
              // 現在の保有ポイント数
              const keys = Object.keys(userData.possessedPointMap);
              if(keys && keys.length > 0){
                for(let i = 0; i < keys.length; i++){
                  const key = Number(keys[i]);
                  if(ptCategoryId === key){
                    possessedPoint = userData.possessedPointMap[key].point ?? 0;
                    let categoryPoint = (possessedPoint) + (formData.grantPoints ?? 0);
                    if(categoryPoint < 0){
                      categoryPoint = 0;
                    }
                    heldPoints = heldPoints + categoryPoint;
                  }else{
                    heldPoints = heldPoints + (userData.possessedPointMap[key].point ?? 0);
                  };
                };
              };
              if(heldPoints < 0){
                heldPoints = 0;
              }
            }else{
              heldPoints = formData.grantPoints && formData.grantPoints >= 0 ? formData.grantPoints : 0;
            };
            if(possessedPoint  + (formData.grantPoints ?? 0) < 0){
              pointHistory.grantPoints = 0 - possessedPoint;
              adjustUser.errorDetail = ConstMessage.POINT_ADJUSTMENT_SHORTAGE.replace('%1', String(pointHistory.grantPoints));
            }
            pointHistory.grantFlg = true;
            pointHistory.grantDate = new Date();
            pointHistory.heldPoints = heldPoints;
            pointHistory.occurrenceDate = new Date();

            pointAdjustData.occurrenceDate = new Date();
          
            // 利用者の保有ポイント数を更新
            await userQuery.updatePossessedPointData(
              currentUser?.tenantId!,
              userData,
              formData.grantPoints ?? 0, 
              ptCategoryId, 
              ptCategoryName
            );
          };
        };
        adjustUsersMap.push(adjustUser);
        if(!userData.accountSuspensionFlg){
          await pointDataQuery.addPointHistory(currentUser?.tenantId!, pointHistory);
          await pointDataQuery.addPointAdjustHistory(currentUser?.tenantId!, pointAdjustData, adjustUsersMap);
        }
        setFormData(newPointAdjustHistory());
        if(userData.accountSuspensionFlg){
          dispatch(alertOpen(AlertValue(ConstMessage.ERR_USER_ACCOUNT_SUSPENSION, "danger")));
        }else{
          dispatch(alertOpen(AlertValue(ConstMessage.SUCCESS_SAVE_DATA.replace('%1', "ポイント調整"), "success")));
        }
      };
      toggleConfirm();
      AdjustmentToggle();
      setSubmitFlg(!submitFlg);
    }catch(err){
      console.error(err);
      dispatch(alertOpen(AlertValue(ConstMessage.ERR_SAVE, "danger")));
    };
  };

  return (
    <div className="h-full">
      <Progress
        subText={ConstMessage.PROGRESS_SUB_TEXT}
        open={loadProgress >= 0 && loadProgress < 100}
        progressNum={loadProgress}
        color={"green"}
      />
      <div className="sm:flex sm:items-center pl-6 pt-6 pb-4">
        <div className={'flex ml-1'}>
          <Button
            size={"sm"}
            className={"w-[132px]"}
            onClick={async () => {
              if (await checkOption("point", dispatch)) {
                PointHistoryExportToggle();
                }
              }
            }
          >
            履歴出力
          </Button>
          <Button
            size={"sm"}
            className={"w-[132px] ml-2 "}
            onClick={async () => {
              if (await checkOption("point", dispatch)) {
                AdjustmentToggle();
                }
              }
            }
            disabled={(user?.accountSuspensionFlg || !user?.lastName || user?.lastName === "") ? true : false}
          >
            ポイント調整
          </Button>
        </div>
      </div>
      <div>
        {isLoad === true ? <Spiner /> : (
          <>
            <div className={"px-6 pb-3"}>
              <UserPointHistorySearch
              pointList={userPointHistoryList}
              setSearchUserPointHistoryList={setSearchUserPointHistoryList}
              setSearchUserPointHistoryFlg={setSearchUserPointHistoryFlg}
              ptNameList={ptNameList}
              pointCategoryList={pointCategoryList}
              pointTypeList={pointTypeList}
              />
            </div>
            <div className={"px-6 pb-6"}>
              <TableList
                header
                gridCol={columns}
                gridRow={rowList}
                gridRowLength={0}
                selectNumberList={selectNumberList}
                setSelectNumber={setSelectNumber}
                minWidth="min-w-[900px]"
                limit={selectNumber}
                defaultSortKey={columns[5].field}
                defaultSortOrder={"desc"}
                sortKeyList={[{key: "occurrenceDateTime", sort: "desc"}, {key: "createDateTime", sort: "desc"}]}
                firstPageFlg={firstPageFlg}
                setFirstPageFlg={setFirstPageFlg}
              />
            </div>
            {/* ポイント調整 */}
            <UserPointAdjustmentModal
              children={undefined}
              open={pointAdjustmentIsOpen}
              toggle={AdjustmentToggle}
              closeOnClickOutside={false}
              pointCategoryList={pointCategoryList}
              pointTypeList={pointTypeList}
              onClickConfirm={onClickConfirm}
              ptAwardedSettingsList={ptAwardedSettingsList}
            />
            {/* 履歴出力 */}
            <PointHistoryExportModal
              children={undefined}
              open={isOpen}
              toggle={PointHistoryExportToggle}
              closeOnClickOutside={false}
              setLoadProgress={setLoadProgress}
              company={company}
              pointHistoryList={searchUserPointHistoryFlg? searchUserPointHistoryList : userPointHistoryList}
              dispName={"userPointHistory"}
              userId={userId}
            />
            <RegistConfirmationModal
              toggle={toggleConfirm}
              open={isOpenConfirm}
              children={""}
              closeOnClickOutside={false}
              handle={onClickSubmit}
              title={ConstMessage.POINT_ADJUSTMENT_TITLE}
              body={modalMsg}
            />
          </>
        )
        }
      </div>
    </div>
  );
}